import { Component, Input } from '@angular/core';

declare var require: any;

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

 

@Component({
  selector: 'combinedaddbilling',
  templateUrl: './combinedaddbilling.component.html',
  styleUrls: [
    './combinedaddbilling.component.scss']
  , animations: [routerTransition()]
})

export class CombinedAddBillingComponent {
  public FormattedCode: any;
  public PatientTypedata: any;
  public TypeofBill: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private parserFormatter: NgbDateParserFormatter,

  ) { }

  ngOnInit() {
    this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.PatientTypedata = this.route.snapshot.paramMap.get('PatientType');
    this.TypeofBill = this.route.snapshot.paramMap.get('TypeofBill');
  }

}
